import React from 'react'
import { Link } from 'react-router-dom';
import { useState } from 'react'



import 'animate.css';

export const Mensaje = ({setUrl}) => {
    const [etapa] = useState(1)
    return (
        <div className="card card-transparent stats-card animate__animated animate__heartBeat">
            <div className="card-body text-center">
                {
                    etapa === 1 
                    ? <>
                        <h4 className="text-warning">
                            <span className="mr-4">Si decidiste compartir habitación con otro graduado</span>
                            <Link to="/habitacion" onClick={() => setUrl('/habitacion')} className="btn btn-outline-primary">¡Búscalo Aquí!</Link>
                        </h4>
                      </>
                    : etapa === 2
                    ? <>
                        hola 2
                      </>
                    : <>
                        hola 3
                      </>
                }
            </div>
        </div>
    )
}
